import { faqItems } from '@/mocks/homeData';

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[900px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
            常见问答
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            关于今日看料，你想知道的都在这里
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="bg-background-100 rounded-xl p-5 md:p-6 hover:bg-background-200/70 transition-colors duration-200"
            >
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2 flex items-start gap-2">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">
                  <i className="ri-question-answer-line"></i>
                </span>
                {item.question}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-6">
                {item.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}